<nsa-modal *transloco="let transloco">
  <div modal-header-icon class="modal-avatar rounded-md">
    <span class="material-symbols-outlined icon-md" aria-hidden="true">support_agent</span>
  </div>

  <ng-container modal-body>
    <p class="text-sm text-ink-2">{{ transloco(data.message) }}</p>

    <div class="mt-4 flex items-center gap-3 rounded-md border border-line bg-surface-3 px-4 py-3">
      <span class="w-9 h-9 rounded-md bg-primary-50 text-primary-700 grid place-items-center shrink-0">
        <span class="material-symbols-outlined text-[20px]" aria-hidden="true">mail</span>
      </span>
      <a
        [href]="'mailto:' + data.email"
        class="me-auto text-sm font-semibold text-primary-700 hover:underline break-all">
        {{ data.email }}
      </a>
      <nsa-button
        nsaId="nsf-support-copy-email"
        type="button"
        size="sm"
        [outlined]="true"
        color="secondary"
        icon="content_copy"
        [title]="transloco('MODAL.SUPPORT.COPY')"
        (click)="onCopyEmail()">
        {{ copied() ? transloco('MODAL.SUPPORT.COPIED') : transloco('MODAL.SUPPORT.COPY') }}
      </nsa-button>
    </div>

    @if(copied()) {
      <span class="sr-only" role="status" aria-live="polite">{{ transloco('MODAL.SUPPORT.COPIED_STATUS') }}</span>
    }
  </ng-container>
</nsa-modal>